<template>
  <!-- 更多 -->
  <div class="details" v-loading="loading">
    <!-- 内容1 -->
    <el-row>
      <el-col :span="23" :offset="0.5">
        <div class="title1">
          <!-- 内容1内部 -->
          <el-row :gutter="24">
            <el-col :span="8" :offset="2">
              <div class="title1_left">
                <img :src="detailsImage" alt :class="{widthMax:WidthSize<767}" />
              </div>
            </el-col>
            <el-col :span="12" :class="{none:WidthSize<767}">
              <div class="title1_content">
                <ul>
                  <li>{{detailsName}}</li>
                  <li>
                    <p>{{bookIntroduce}}</p>
                  </li>
                  <li>
                    <el-rate v-model="value1" @click="xing(value1)"></el-rate>
                  </li>
                  <li :class="{none:WidthSize<1023}"></li>
                  <li>价格</li>
                  <li>免费</li>
                </ul>
              </div>
            </el-col>
            <el-col :span="10" :class="{none:WidthSize >= 767}">
              <div class="title1_content2">
                <!-- <ul>
                  <li>{{detailsName}}</li>
                  <li>
                    <p>{{bookIntroduce}}</p>
                  </li>
                </ul> -->
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 内容2 -->
    <el-row>
      <el-col :span="23" :offset="0.5">
        <div class="title2">
          <el-row :gutter="24">
            <el-col :span="20" :offset="2">
              <div class="title2_left">
                <el-row>
                  <el-col :span="24">
                    <div class="name">
                      <ul>
                        <li :class="{active:num==1}" @click="num=1">课时列表</li>
                        <li :class="{active:num==0}" @click="num=0">课程概览</li>
                        <li :class="{active:num==2}" @click="num=2">评价</li>
                        <li :class="{active:num==3}" @click="num=3">笔记</li>
                      </ul>
                    </div>
                    <!-- 1 -->
                    <div class="content1" v-show="num==0">
                      <div class="curriculum">
                        <span></span>
                        <span>课程介绍</span>
                      </div>
                      <div class="piece-body">
                        <span class="wu">暂无课程介绍</span>
                      </div>
                    </div>
                    <!-- 2 -->
                    <div class="content2" v-show="num==1">
                      <div>
                        <!-- , -->
                        <div
                          class="content2_title"
                          @click.prevent="courses"
                          v-for="ueseLists in userList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                          :key="ueseLists.id"
                        >
                          <!-- <router-link :to="'/videos'"> -->
                          <ul @click="zhifu(ueseLists)">
                            <li>
                              <i class="el-icon-view"></i>
                            </li>
                            <li>{{ueseLists.title}}</li>
                            <li>
                              <img
                                src="../assets/img/mf.png"
                                alt="此视频为免费"
                                v-show="ueseLists.state == 0"
                              />
                            </li>
                            <li>
                              <img
                                src="../assets/img/complete.png"
                                alt
                                v-show="ueseLists.state == 1"
                              />
                            </li>
                            <li>
                              <img src="../assets/img/money.png" alt v-show="ueseLists.state == 2"/>
                            </li>
                          </ul>
                          <!-- </router-link> -->
                        </div>
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="currentPage"
                          :page-sizes="[5, 10, 20, 40]"
                          :page-size="pagesize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="userList.length"
                        ></el-pagination>
                        <!-- <div class="lun" v-show="detailsList.length">
        <span class="wu">暂无课程</span>
                        </div>-->
                        <!-- <div class="course" v-show="course"></div> -->
                      </div>
                    </div>
                    <!-- 3 -->
                    <div class="content3" v-show="num==2">
                      <p>暂时没有评论</p>
                    </div>
                    <!-- 4 -->
                    <div class="content3" v-show="num==3">
                      <p>暂时没有笔记</p>
                    </div>
                  </el-col>

                  <!-- 右边 -->
                </el-row>
              </div>
            </el-col>
            <el-col :span="0" :offset="1">
              <div class="title2_right">
                <el-row>
                  <!-- 1 -->
                  <el-col :span="24">
                    <div class="one">
                      <div class="one_title">推荐班级</div>
                      <div class="lun">
                        <el-carousel height="120px">
                          <el-carousel-item v-for="item in 4" :key="item">
                            <h3 class="small">{{ item }}</h3>
                          </el-carousel-item>
                        </el-carousel>
                      </div>
                    </div>
                  </el-col>
                  <!-- 2 -->
                  <el-col :span="24">
                    <div class="one">
                      <div class="one_title">授课老师</div>
                      <div class="lun">
                        <ul>
                          <li>
                            <img src="#" alt />
                          </li>
                          <li>
                            <span>大冶</span>
                          </li>
                          <li>
                            <span>大冶</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </el-col>
                  <!-- 3 -->
                  <el-col :span="24">
                    <div class="one">
                      <div class="one_title">最新学员</div>
                      <div class="lun">
                        <span class="wu">暂无学员</span>
                      </div>
                    </div>
                  </el-col>
                  <!-- 4 -->
                  <el-col :span="24">
                    <div class="one">
                      <div class="one_title">学员动态</div>
                      <div class="lun">
                        <span class="wu">还没有动态</span>
                      </div>
                    </div>
                  </el-col>
                  <!-- 结束 -->
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  name: "detail",
  props: ["id"],
  data() {
    return {
      value1: null,
      value2: null,
      WidthSize: 1010,
      loading: false,
      course: false,
      wo: ["wod", "nide"],
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      userList: [],
      pointswan: "",
      num: 1,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"]
    };
  },
  created() {
    // 获取详情数据
    let date = {
      token: this.$cookie.get("token"),
      id: this.id
    };
    this.$store.dispatch("getDetails", date).then(response => {
      // console.log(response.data.context.video_list)
      this.userList = response.data.context.video_list;
    });
    // 给win添加事件
    // console.log(window)
    window.addEventListener("resize", this.handleResize);
    this.handleResizeing();
  },
  mounted() {
  },
  methods: {
    // 分页
    handleSizeChange: function(size) {
      this.pagesize = size;
      // console.log(this.pagesize)  //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      // console.log(this.currentPage)  //点击第几页
    },
    //打分
    xing() {
      // console.log(e)
    },
    courses() {
      this.course = !this.course;
      // console.log()
    },
    // 适配
    handleResizeing() {
      this.WidthSize = window.outerWidth;
    },
    handleResize(e) {
      this.WidthSize = e.currentTarget.innerWidth;
    },
    // 点击进入详情页
    zhifu(e) {
      // 获取token 
      let token = "";
      // 不存在
      if (!this.$cookie.get("token")) {
        token = "";
      } else {
        token = this.$cookie.get("token").toString();
      }
      // 免费的状态
      if (e.state == 0) {
        this.$router.push({
          path: "/video/?id=" + e.id + "&points=" + e.points + "&token=" + token,
          query: {
            video_url: this.video_url
          }
        });
        
        // 买过的状态
      } else if (e.state == 1) {
        // console.log()
        // 判断是否为登录状态
        if (!this.$cookie.get("token")) {
          this.$router.push("/login");
        } else {
          this.$router.push({
          path: "/video/?id=" + e.id + "&points=" + e.points + "&token=" + token,
          query: {
            video_url: this.video_url
          }
        });
        }
        // 未买的
      } else if (e.state == 2) {
        // console.log("我是2")
        let data = e;
        // 判断是否是登录状态
        this.login(data);
      }
    },
    login(log) {
      if (!this.$cookie.get("token")) {
        this.$router.push("/login");
      } else {
        this.open(log);
      }
    },
    // 未买的，获取信息
    open(e) {
      // console.log(e);
      console.log(this.detailsList)
      // 当state == 2
      if (e.state == 2) {
        // 做延迟
        this.loading = true;
        // 需要购买时发送的信息
        let data = {
          id: e.id,
          points: e.points,
          token: this.$cookie.get("token")
        };
        // 延迟关闭
        setTimeout(() => {
          this.loading = false;
        }, 1000);
        // console.log(e.title)
        // 提示价钱
        this.$confirm(
          '<p style="color:#409EFF;">用户名:' +
            this.$cookie.get("token") +
            "</p>" +
            '<p style="color:#409EFF;">书名:' +
            this.detailsName +
            "</p>" +
            '<p style="color:#409EFF;">课程:' +
            e.title +
            "</p>" +
            '<p style="color:#409EFF">需要付费的点数:' +
            '<span style="color:#FFA500;font-weight: 600;">$' +
            e.points +
            ".00</span>" +
            "</p>",
          // '<p style="color:#212121;">' +   +'.00</p>',
          "您正在使用点数支付",
          {
            confirmButtonText: "确定订单",
            cancelButtonText: "取消",
            type: "success",
            dangerouslyUseHTMLString: true
          }
        )
          .then(() => {
            // console.log("去付费")
            // // 确认支付
            this.$store.dispatch("getFu", data).then(res => {
              this.pointswan = res.data.code;
              // console.log(res)
              this.$message("请稍等，正在支付...");
              setTimeout(() => {
                if (res.data.code == 4002) {
                  this.$message.error(res.data.errmsg);
                  this.$router.push("/pay");
                } else {
                  this.$message({
                    message: "你支付成功了,快去前往知识的海洋吧",
                    type: "success"
                  });
                }
              }, 3000);
              //将页面刷新
              setTimeout(() => {
                window.location.reload();
              }, 4000);
              // 提示
            });
          })
          .catch(() => {
            console.log("取消");
          });
      } else {
        return false;
      }
    }
  },
  computed: {
    // 获取 详情页的所有信息
    bookIntroduce() {
      return this.$store.state.DetailsModule.bookIntroduce;
    },
    detailsList() {
      return this.$store.state.DetailsModule.detailsList;
    },
    detailsName() {
      return this.$store.state.DetailsModule.detailsName;
    },
    detailsImage() {
      return this.$store.state.DetailsModule.detailsImage;
    }
  }
};
</script>

<style lang="scss">
.bottm{
  display: block;
}
.widthMax {
  // width: 7.5rem !important;
  margin-bottom: 0rem auto;
}
.details {
  width: 100%;
  margin-top: 0.1rem;
  // overflow: hidden;
  .title1 {
    height: 4rem;

    // background-color: red;
    .title1_left,
    .title1_content,
    .title1_right {
      height: 4rem;

      // background-color: yellow;
      margin-top: 0.5rem;
    }
    .title1_left {
      // overflow: hidden;
      img {
        width: 3.33rem;
        height: 3.33rem;
        border-radius: 0.25rem;
        float: left;
        // margin-top: 0.2rem;
      }
    }
    .title1_content2 {
      ul {
        width: 100%;
        height: 100%;
        position: relative;
        li {
          position: absolute;
          left: 1.3rem;
        }
        li:first-child {
          top: 0.7rem;
          // font-size: 0.3rem;
          left: -0rem;
          font-weight: 600;
          color: blue;
          width: 5rem;
          // text-alig;

          // background-color: red;
        }
        li:last-child {
          top: 1.2rem;
          left: -0rem;
          height: 2.6rem;
          width: 5rem;
          // overflow: hidden;
          // background-color: red;
          color: #919191;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
          p {
            text-align: left;
            text-indent: 2em;
          }
        }
      }
    }
    .title1_content {
      ul {
        width: 100%;
        height: 100%;
        position: relative;
        li {
          position: absolute;
          left: 0.5rem;
        }
        li:first-child {
          top: 0rem;
          font-size: 0.5rem;
        }
        li:first-child:hover {
          color: #0095dd;
        }
        li:nth-child(2) {
          top: 2.5rem;
          color: #919191;
          font-size: 0.3rem;
          width: 80%;
          height: 1.5rem;
          // background-color: red;
          overflow: hidden;

          p {
            text-align: left;
            text-indent: 2em;
          }
          // text-overflow : clip;
          text-overflow: ellipsis;
        }
        li:nth-child(3) {
          top: 2rem;
        }
        li:nth-child(4) {
          top: 1rem;
          left: 3rem;
          color: #919191;
        }
        li:nth-child(5) {
          top: 1rem;
          color: #919191;
          font-size: 0.3rem;
        }
        li:nth-child(6) {
          top: 1rem;
          left: 1.5rem;
          color: #70d445 !important;
          font-size: 0.3rem;
        }
      }
    }
    .title1_right {
      // background-color: yellow;
      button {
        width: 2rem;
      }
    }
  }
  .title2 {
    margin-top: 0.5rem;
    .title2_left {
      // height: 37.5rem;
      margin-bottom: 1.875rem;
      background-color: #ffffff;
      border: 0.01rem solid #e4ecf3;
      .name {
        height: 1rem;
        width: 97%;
        margin: 0rem auto;
        // background-color: red;
        border-bottom: 0.01rem solid #e4ecf3;
        ul {
          width: 100%;
          // background-color: red;
          float: left;
          height: 1rem;
          line-height: 1rem;
          .active {
            border-bottom: 0.01rem solid #70d445;
            color: #70d445;
          }
          li {
            height: 1rem;
            width: 22%;
            display: inline-block;
            color: #313131;
            // margin-left: 0.625rem;
            // margin-right: 0.625rem;
          }
        }
      }
      // 内容1
      .content1 {
        .curriculum {
          width: 97%;
          margin: 0.3rem auto;

          overflow: hidden;
          span {
            display: inline-block;
            float: left;
            color: #313131;
          }
          span:first-child {
            width: 0.05rem;
            height: 0.5rem;
            background-color: #70d445;
            margin-right: 0.2rem;
          }
        }
        .piece-body {
          width: 97%;
          text-align: left;
          margin: 1.875rem auto;
          color: #919191;
          p {
            line-height: 50px;
          }
        }
      }

      // 内容2
      .content2 {
        width: 97%;
        margin: 0rem auto;
        // border-radius: 5%;
        .content2_title:hover {
          background-color: #d3d3d3;
          border-radius: 10px;
        }
        .content2_title {
          width: 100%;
          height: 1rem;
          // background-color: red;
          margin-top: 0.2rem;
          margin-bottom: 0.1rem;
          ul {
            width: 100%;
            height: 1rem;
            position: relative;

            li {
              position: absolute;
              line-height: 1rem;
              color: #313131;
            }
            li:first-child {
              left: 1.25rem;
            }
            li:nth-child(2) {
              left: 3.125rem;
              color: #919191;
            }
            li:nth-child(3) {
              right: 1.25rem;
              margin-bottom: 0.5rem;
              img {
                width: 0.4rem;
                height: 0.4rem;
                margin-top: 0.3rem;
              }
            }
            li:nth-child(4) {
              right: 1.25rem;
              margin-bottom: 0.5rem;
              img {
                width: 0.4rem;
                height: 0.4rem;
                margin-top: 0.3rem;
              }
            }
            li:last-child {
              right: 1.25rem;
              margin-bottom: 0.8rem;
              img {
                width: 0.4rem;
                height: 0.4rem;
                margin-top: 0.3rem;
              }
            }
          }
        }
        .course {
          width: 100%;
          height: 60px;
          background-color: red;
        }
      }
      // 内容3
      .content3 {
        width: 100%;
        height: 5rem;
        line-height: 5rem;
        color: #919191;
      }
    }
    .title2_right {
      .one {
        height: 180px;
        margin-bottom: 40px;
        // background-color: red;
        border: 0.0625rem solid #e4ecf3;
        .one_title {
          height: 50px;
          width: 85%;
          line-height: 60px;
          text-align: left;
          margin-left: 7.5%;
          // padding-left: 20px;
          color: #313131;
          font-size: 16px;
          border-bottom: 0.0625rem solid #e4ecf3;
          // background-color: yellow;
        }
        .lun {
          height: 120px;
          // background-color: red;
          margin-top: 10px;
          overflow: hidden;
          .wu {
            line-height: 120px;
            color: #919191;
            font-size: 14px;
          }
          ul {
            width: 100%;
            height: 100%;
            position: relative;
            li {
              display: inline-block;
              position: absolute;

              // background-color: red;
            }
            li:first-child {
              left: 20px;
              top: 20px;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              img {
                border-radius: 50%;
              }
            }
            li:nth-child(2) {
              left: 80px;
              top: 20px;
              font-size: 16px;
              color: #919191;
              font-weight: 400;
            }
            li:last-child {
              left: 80px;
              top: 50px;
              font-size: 14px;
              color: #919191;
            }
          }
        }
      }
    }
  }
}
</style>
